import { 
  Component, 
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject,
  ViewChild,
  forwardRef
} from '@angular/core';

import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FormGroup, FormControl, Validators} from '@angular/forms';
import { DatexFormControl } from './models/datex-form-control';
import { ListItemModel, ELoadingStatus } from './components/list.component';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_dock_doors_list_ComponentContextService } from './FootprintManager.dock_doors_list.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { DockAppointments_areas_dd_multiComponent } from './DockAppointments.areas_dd_multi.component'


import { FootprintManager_dock_door_cardComponent } from './FootprintManager.dock_door_card.component';

interface IFootprintManager_dock_doors_listComponentEntity {
Id?: number, EligibleForAllocation?: boolean, IsPrimaryPick?: boolean, Name?: string, ParentId?: number, StatusId?: number, ChildLocationContainers?: { IsLoose?: boolean, Name?: string }[]}

class FootprintManager_dock_doors_listComponentItemModel extends ListItemModel {
  list: FootprintManager_dock_doors_listComponent;
  entity: IFootprintManager_dock_doors_listComponentEntity;



  get $content_FootprintManager_dock_door_card_inParams_dockDoorId(): number {
    if (!this.entity) return null; 
    const $item = this;
    const $utils = this.$utils;
    const $list = this.list;
    const expr = $item.entity.Id;
    
    return expr;
  }

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_dock_doors_list_ComponentContextService,
   ) {
    super();
  }

  private $unsubscribe$ = new Subject();
  destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $initializeExisting(list: FootprintManager_dock_doors_listComponent, entity: IFootprintManager_dock_doors_listComponentEntity) {
    this.list = list;
    this.entity = entity;

    this.styles = new Styles(
      ['small-card'], 
      { 
        width: '20%', 
        height: '300px' 
      }
    );
  }
}

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => DockAppointments_areas_dd_multiComponent),
    forwardRef(() => FootprintManager_dock_door_cardComponent)
  ],
  selector: 'FootprintManager-dock_doors_list',
  templateUrl: './FootprintManager.dock_doors_list.component.html'
})
export class FootprintManager_dock_doors_listComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { warehouseIds?: number[], appointmentType?: string, active?: boolean } = { warehouseIds: [], appointmentType: null, active: null };
  //#region Inputs
  @Input('warehouseIds') set $inParams_warehouseIds(v: number[]) {
    this.inParams.warehouseIds = v;
  }
  get $inParams_warehouseIds(): number[] {
    return this.inParams.warehouseIds;
  }
  @Input('appointmentType') set $inParams_appointmentType(v: string) {
    this.inParams.appointmentType = v;
  }
  get $inParams_appointmentType(): string {
    return this.inParams.appointmentType;
  }
  @Input('active') set $inParams_active(v: boolean) {
    this.inParams.active = v;
  }
  get $inParams_active(): boolean {
    return this.inParams.active;
  }
  //#endregion Inputs

  //#region Outputs
  //#endregion
  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  topToolbar = {
      refresh: new ToolModel(new ButtonModel('refresh', new ButtonStyles(null, null), false, false, false, ' ', 'icon-ic_fluent_arrow_clockwise_20_regular', () => { const $utils = this.$utils; const $list = this; return 'Refresh'; })
    , false)
  };

  formGroup: FormGroup = new FormGroup({
    area: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    area: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['area'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Area', false, false),
  }

  //#region filters inParams
  cacheValueFor_$fields_area_selector_inParams_warehouseIds: number[];
  get $fields_area_selector_inParams_warehouseIds(): number[] {
    const $list = this;
    const $utils = this.$utils;
    const expr = $list.inParams.warehouseIds;
    
    if(!isEqual(this.cacheValueFor_$fields_area_selector_inParams_warehouseIds, expr)) {
      this.cacheValueFor_$fields_area_selector_inParams_warehouseIds = expr;
    }
    return this.cacheValueFor_$fields_area_selector_inParams_warehouseIds;
  }

  //#endregion filters inParams

  entities: IFootprintManager_dock_doors_listComponentEntity[] = [];
  pageSize = 15;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus: ELoadingStatus = ELoadingStatus.Loading;

  items: FootprintManager_dock_doors_listComponentItemModel[] = [];
  

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_dock_doors_list_ComponentContextService,
) { 
    super();
    this.title = 'Dock doors';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {

    const $list = this;
    const $utils = this.$utils;



    this.initialized = true;
    this.refresh(true, true, null);
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.refresh();
  }
 
  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    this.$reset();
    const result = this.$dataLoad();
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    
  }

  $reset() {
    this.pageSkip = 0;
    this.entities = [];
    this.items.forEach(i => i.destroy());
    this.items = [];
  }


  $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $list = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      warehouseIds:  $list.inParams.warehouseIds ,
      appointmentType:  $list.inParams.appointmentType ,
      statusId:  ($list.inParams.active == true) ? 1 : 2 ,
      parentIds:  $list.filters.area.control.value ,
    };
    this.$datasources.DockAppointments.ds_dock_doors_by_warehouseIds_list.getList(inParams)
    .then(data => {
      this.entities.push(...data.result);
      this.totalCount = data.totalCount;
      this.$dataLoaded(data.result);
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    })
    .catch(error => {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    });
  }

  async $dataLoaded(data: IFootprintManager_dock_doors_listComponentEntity[]) {
    for (let entity of data) {
      const item = new FootprintManager_dock_doors_listComponentItemModel(
        this.$utils,
        this.$settings,
        this.$shell, 
        this.$datasources,
        this.$flows,
        this.$reports,
        this.$localization,
        this.$operations,
        this.$logger,
        this.$context);
      item.$initializeExisting(this, entity);
      this.items.push(item);
    } 
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
  
  //#region private flows
  on_refresh(event = null) {
    return this.on_refreshInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refreshInternal(
    $list: FootprintManager_dock_doors_listComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_dock_doors_list_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $list.refresh();
  }
  //#endregion private flows

  close() {
    this.$finish.emit();
  }
}
